import type { ColDef } from "~/components/grid/AgGrid";
import type { ColumnDisplayNameResolver, SetFilterLabelResolver } from "~/helpers/grid/filterModelToText";
import type { MruFilterEntry } from "~/hooks/useMruFilters";

import filterModelToText, { FilterModelMap, setFilterValueKeys } from "~/helpers/grid/filterModelToText";
import i18n from "~/i18n/i18n";

const filterModelToDisplayString = (
	filterModel: FilterModelMap | null,
	columnDefs: ColDef[],
	pathname = "",
	labelResolver?: SetFilterLabelResolver,
	getDisplayName?: ColumnDisplayNameResolver
): string => {
	const segments = filterModelToText(filterModel, columnDefs, pathname, labelResolver, getDisplayName);
	if (segments.length === 0) return "";
	return segments
		.map((s) => `${s.label}: ${s.text}`)
		.reduce((left, right) => i18n.t("common:grid.filterText.joined", { left, right }));
};

export const mruEntryDisplayString = (
	entry: MruFilterEntry,
	columnDefs: ColDef[],
	pathname: string,
	labelResolver?: SetFilterLabelResolver,
	getDisplayName?: ColumnDisplayNameResolver
): string => {
	const resolveSetLabel: SetFilterLabelResolver = (field, key) =>
		labelResolver?.(field, key) ?? entry.setLabels?.[field]?.[key];
	const hasUnnamedSetValue = setFilterValueKeys(entry.filterModel).some(
		({ field, key }) => resolveSetLabel(field, key) === undefined
	);
	if (entry.displayText && hasUnnamedSetValue) return entry.displayText;
	return filterModelToDisplayString(entry.filterModel, columnDefs, pathname, resolveSetLabel, getDisplayName);
};

export default filterModelToDisplayString;
